const LOCAL_BACKEND_URL = 'http://localhost:3001';

const configuredBackendUrl = import.meta.env.VITE_BACKEND_URL?.trim();

const getBackendUrl = () => {
  if (import.meta.env.MODE === 'development') {
    return configuredBackendUrl || LOCAL_BACKEND_URL;
  }

  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.origin;
};

const backendUrl = getBackendUrl();

export const BACKEND_URL = backendUrl.replace(/\/$/, '');
